// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 音色选择弹窗 - 浅色主题 (匹配 VoiceSynthesis) */

/* 背景遮罩 */
.VoiceSelectionModal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: VoiceSelectionModal-fadeIn 0.2s ease-out;
}

@keyframes VoiceSelectionModal-fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* 模态框容器 */
.VoiceSelectionModal-container {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  max-width: 90vw;
  width: 900px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  animation: VoiceSelectionModal-slideUp 0.25s ease-out;
}

@keyframes VoiceSelectionModal-slideUp {
  from { transform: translateY(30px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

/* 标题栏 */
.VoiceSelectionModal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
  background: linear-gradient(90deg, rgba(99, 102, 241, 0.08) 0%, #ffffff 100%);
  flex-shrink: 0;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.VoiceSelectionModal-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
}

.VoiceSelectionModal-close {
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: #9ca3af;
  font-size: 16px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.VoiceSelectionModal-close:hover {
  background: #f3f4f6;
  color: #4b5563;
}

/* 主体内容 */
.VoiceSelectionModal-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f8f9fc;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
}

/* 加载状态 */
.VoiceSelectionModal-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  gap: 16px;
}

.VoiceSelectionModal-loading .spinner-border {
  width: 2.5rem;
  height: 2.5rem;
  border-width: 3px;
  color: #6366f1;
}

.VoiceSelectionModal-loading p {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

/* 警告提示 */
.VoiceSelectionModal-alert {
  margin: 20px;
  border-radius: 10px;
  background: #fffbeb;
  border: 1px solid #fcd34d;
  color: #b45309;
  padding: 16px;
}

/* 标签页导航 */
.VoiceSelectionModal-tabs {
  display: flex;
  flex-wrap: nowrap;
  gap: 6px;
  padding: 12px 16px;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  overflow-x: auto;
  overflow-y: hidden;
  flex-shrink: 0;
  -webkit-overflow-scrolling: touch;
}

.VoiceSelectionModal-tabs::-webkit-scrollbar {
  height: 4px;
}

.VoiceSelectionModal-tabs::-webkit-scrollbar-track {
  background: #f3f4f6;
}

.VoiceSelectionModal-tabs::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 2px;
}

.VoiceSelectionModal-tabs::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

.VoiceSelectionModal-tab {
  padding: 8px 14px;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}

.VoiceSelectionModal-tab:hover {
  border-color: #c7d2fe;
  color: #6366f1;
  background: #eff6ff;
}

.VoiceSelectionModal-tab-active {
  border-color: #6366f1 !important;
  background: #6366f1 !important;
  color: white !important;
}

/* 标签内容区域 */
.VoiceSelectionModal-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  background: #f8f9fc;
}

.VoiceSelectionModal-content::-webkit-scrollbar {
  width: 5px;
}

.VoiceSelectionModal-content::-webkit-scrollbar-track {
  background: transparent;
}

.VoiceSelectionModal-content::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 3px;
}

/* 音色网格 */
.VoiceSelectionModal-voice-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 12px;
}

/* 音色卡片 */
.VoiceSelectionModal-voice-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 12px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  cursor: pointer;
  transition: all 0.15s;
  min-height: 180px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.VoiceSelectionModal-voice-card:hover {
  border-color: #6366f1;
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.1);
  transform: translateY(-2px);
}

.VoiceSelectionModal-voice-card.active {
  border-color: #6366f1;
  border-width: 2px;
  background: rgba(99, 102, 241, 0.04);
}

/* 选中标记 */
.VoiceSelectionModal-voice-check {
  position: absolute;
  top: 8px;
  right: 8px;
  color: #34d399;
  font-size: 16px;
}

/* 音色图标 */
.VoiceSelectionModal-voice-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  border-radius: 10px;
  margin-bottom: 12px;
  color: white;
  font-size: 18px;
  box-shadow: 0 4px 6px rgba(99, 102, 241, 0.2);
}

.VoiceSelectionModal-voice-icon.custom {
  background: linear-gradient(135deg, #10b981 0%, #34d399 100%);
  box-shadow: 0 4px 6px rgba(16, 185, 129, 0.2);
}

/* 音色名称 */
.VoiceSelectionModal-voice-name {
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
  text-align: center;
  margin-bottom: 6px;
  line-height: 1.3;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 音色标签 */
.VoiceSelectionModal-voice-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  justify-content: center;
  margin-bottom: 8px;
  min-height: 20px;
}

.VoiceSelectionModal-voice-tag {
  font-size: 9px;
  padding: 2px 6px;
  border-radius: 3px;
  font-weight: 500;
  background: #f3f4f6 !important;
  color: #6b7280 !important;
}

.VoiceSelectionModal-voice-tag.bg-success {
  background: #ecfdf5 !important;
  color: #10b981 !important;
}

.VoiceSelectionModal-voice-tag.bg-info {
  background: #eef2ff !important;
  color: #6366f1 !important;
}

.VoiceSelectionModal-voice-tag.bg-danger {
  background: #fef2f2 !important;
  color: #ef4444 !important;
}

/* 音色描述 */
.VoiceSelectionModal-voice-desc {
  font-size: 11px;
  color: #6b7280;
  text-align: center;
  line-height: 1.4;
  margin-bottom: 10px;
  flex-grow: 1;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  width: 100%;
}

/* 播放按钮 */
.VoiceSelectionModal-play-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #6366f1;
  border-radius: 6px;
  background: transparent;
  color: #6366f1;
  font-weight: 500;
  font-size: 11px;
  cursor: pointer;
  transition: all 0.15s;
  justify-content: center;
}

.VoiceSelectionModal-play-btn:hover {
  background: #6366f1;
  color: white;
  box-shadow: 0 2px 4px rgba(99, 102, 241, 0.2);
}

.VoiceSelectionModal-play-btn.playing {
  background: #34d399;
  border-color: #34d399;
  color: white;
  box-shadow: 0 2px 4px rgba(52, 211, 153, 0.2);
}

/* 空状态 */
.VoiceSelectionModal-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #6b7280;
  gap: 12px;
}

.VoiceSelectionModal-empty p {
  font-size: 13px;
  color: #9ca3af;
  margin: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .VoiceSelectionModal-container {
    max-width: 95vw;
    max-height: 90vh;
  }

  .VoiceSelectionModal-voice-grid {
    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
    gap: 10px;
  }

  .VoiceSelectionModal-voice-card {
    padding: 12px 10px;
    min-height: 160px;
  }

  .VoiceSelectionModal-voice-icon {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/VoiceSelectionModal/VoiceSelectionModal.css"],"names":[],"mappings":"AAAA,sCAAsC;;AAEtC,SAAS;AACT;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,qDAAqD;AACvD;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,6EAA6E;EAC7E,cAAc;EACd,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,SAAS;AACT;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;AACf;;AAEA,UAAU;AACV;EACE,aAAa;EACb,iBAAiB;EACjB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,cAAc;EACd,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,6CAA6C;AAC/C;;AAEA,SAAS;AACT;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,SAAS;AACT;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,WAAW;AACb;;AAEA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,UAAU;AACV;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":["/* 音色选择弹窗 - 浅色主题 (匹配 VoiceSynthesis) */\n\n/* 背景遮罩 */\n.VoiceSelectionModal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(2px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  animation: VoiceSelectionModal-fadeIn 0.2s ease-out;\n}\n\n@keyframes VoiceSelectionModal-fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n/* 模态框容器 */\n.VoiceSelectionModal-container {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 16px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);\n  max-width: 90vw;\n  width: 900px;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  animation: VoiceSelectionModal-slideUp 0.25s ease-out;\n}\n\n@keyframes VoiceSelectionModal-slideUp {\n  from { transform: translateY(30px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n/* 标题栏 */\n.VoiceSelectionModal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid #e5e7eb;\n  background: linear-gradient(90deg, rgba(99, 102, 241, 0.08) 0%, #ffffff 100%);\n  flex-shrink: 0;\n  border-top-left-radius: 16px;\n  border-top-right-radius: 16px;\n}\n\n.VoiceSelectionModal-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.VoiceSelectionModal-close {\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: transparent;\n  color: #9ca3af;\n  font-size: 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.15s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.VoiceSelectionModal-close:hover {\n  background: #f3f4f6;\n  color: #4b5563;\n}\n\n/* 主体内容 */\n.VoiceSelectionModal-body {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: #f8f9fc;\n  border-bottom-left-radius: 16px;\n  border-bottom-right-radius: 16px;\n}\n\n/* 加载状态 */\n.VoiceSelectionModal-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  gap: 16px;\n}\n\n.VoiceSelectionModal-loading .spinner-border {\n  width: 2.5rem;\n  height: 2.5rem;\n  border-width: 3px;\n  color: #6366f1;\n}\n\n.VoiceSelectionModal-loading p {\n  font-size: 14px;\n  color: #6b7280;\n  margin: 0;\n}\n\n/* 警告提示 */\n.VoiceSelectionModal-alert {\n  margin: 20px;\n  border-radius: 10px;\n  background: #fffbeb;\n  border: 1px solid #fcd34d;\n  color: #b45309;\n  padding: 16px;\n}\n\n/* 标签页导航 */\n.VoiceSelectionModal-tabs {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 6px;\n  padding: 12px 16px;\n  background: #ffffff;\n  border-bottom: 1px solid #e5e7eb;\n  overflow-x: auto;\n  overflow-y: hidden;\n  flex-shrink: 0;\n  -webkit-overflow-scrolling: touch;\n}\n\n.VoiceSelectionModal-tabs::-webkit-scrollbar {\n  height: 4px;\n}\n\n.VoiceSelectionModal-tabs::-webkit-scrollbar-track {\n  background: #f3f4f6;\n}\n\n.VoiceSelectionModal-tabs::-webkit-scrollbar-thumb {\n  background: #d1d5db;\n  border-radius: 2px;\n}\n\n.VoiceSelectionModal-tabs::-webkit-scrollbar-thumb:hover {\n  background: #9ca3af;\n}\n\n.VoiceSelectionModal-tab {\n  padding: 8px 14px;\n  border: 1px solid #e5e7eb;\n  background: #f9fafb;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #6b7280;\n  cursor: pointer;\n  transition: all 0.15s;\n  white-space: nowrap;\n}\n\n.VoiceSelectionModal-tab:hover {\n  border-color: #c7d2fe;\n  color: #6366f1;\n  background: #eff6ff;\n}\n\n.VoiceSelectionModal-tab-active {\n  border-color: #6366f1 !important;\n  background: #6366f1 !important;\n  color: white !important;\n}\n\n/* 标签内容区域 */\n.VoiceSelectionModal-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n  background: #f8f9fc;\n}\n\n.VoiceSelectionModal-content::-webkit-scrollbar {\n  width: 5px;\n}\n\n.VoiceSelectionModal-content::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.VoiceSelectionModal-content::-webkit-scrollbar-thumb {\n  background: #d1d5db;\n  border-radius: 3px;\n}\n\n/* 音色网格 */\n.VoiceSelectionModal-voice-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n  gap: 12px;\n}\n\n/* 音色卡片 */\n.VoiceSelectionModal-voice-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 16px 12px;\n  border-radius: 10px;\n  border: 1px solid #e5e7eb;\n  background: #ffffff;\n  cursor: pointer;\n  transition: all 0.15s;\n  min-height: 180px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.VoiceSelectionModal-voice-card:hover {\n  border-color: #6366f1;\n  background: #ffffff;\n  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.1);\n  transform: translateY(-2px);\n}\n\n.VoiceSelectionModal-voice-card.active {\n  border-color: #6366f1;\n  border-width: 2px;\n  background: rgba(99, 102, 241, 0.04);\n}\n\n/* 选中标记 */\n.VoiceSelectionModal-voice-check {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  color: #34d399;\n  font-size: 16px;\n}\n\n/* 音色图标 */\n.VoiceSelectionModal-voice-icon {\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);\n  border-radius: 10px;\n  margin-bottom: 12px;\n  color: white;\n  font-size: 18px;\n  box-shadow: 0 4px 6px rgba(99, 102, 241, 0.2);\n}\n\n.VoiceSelectionModal-voice-icon.custom {\n  background: linear-gradient(135deg, #10b981 0%, #34d399 100%);\n  box-shadow: 0 4px 6px rgba(16, 185, 129, 0.2);\n}\n\n/* 音色名称 */\n.VoiceSelectionModal-voice-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1f2937;\n  text-align: center;\n  margin-bottom: 6px;\n  line-height: 1.3;\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* 音色标签 */\n.VoiceSelectionModal-voice-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  justify-content: center;\n  margin-bottom: 8px;\n  min-height: 20px;\n}\n\n.VoiceSelectionModal-voice-tag {\n  font-size: 9px;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-weight: 500;\n  background: #f3f4f6 !important;\n  color: #6b7280 !important;\n}\n\n.VoiceSelectionModal-voice-tag.bg-success {\n  background: #ecfdf5 !important;\n  color: #10b981 !important;\n}\n\n.VoiceSelectionModal-voice-tag.bg-info {\n  background: #eef2ff !important;\n  color: #6366f1 !important;\n}\n\n.VoiceSelectionModal-voice-tag.bg-danger {\n  background: #fef2f2 !important;\n  color: #ef4444 !important;\n}\n\n/* 音色描述 */\n.VoiceSelectionModal-voice-desc {\n  font-size: 11px;\n  color: #6b7280;\n  text-align: center;\n  line-height: 1.4;\n  margin-bottom: 10px;\n  flex-grow: 1;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  width: 100%;\n}\n\n/* 播放按钮 */\n.VoiceSelectionModal-play-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #6366f1;\n  border-radius: 6px;\n  background: transparent;\n  color: #6366f1;\n  font-weight: 500;\n  font-size: 11px;\n  cursor: pointer;\n  transition: all 0.15s;\n  justify-content: center;\n}\n\n.VoiceSelectionModal-play-btn:hover {\n  background: #6366f1;\n  color: white;\n  box-shadow: 0 2px 4px rgba(99, 102, 241, 0.2);\n}\n\n.VoiceSelectionModal-play-btn.playing {\n  background: #34d399;\n  border-color: #34d399;\n  color: white;\n  box-shadow: 0 2px 4px rgba(52, 211, 153, 0.2);\n}\n\n/* 空状态 */\n.VoiceSelectionModal-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  color: #6b7280;\n  gap: 12px;\n}\n\n.VoiceSelectionModal-empty p {\n  font-size: 13px;\n  color: #9ca3af;\n  margin: 0;\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .VoiceSelectionModal-container {\n    max-width: 95vw;\n    max-height: 90vh;\n  }\n\n  .VoiceSelectionModal-voice-grid {\n    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));\n    gap: 10px;\n  }\n\n  .VoiceSelectionModal-voice-card {\n    padding: 12px 10px;\n    min-height: 160px;\n  }\n\n  .VoiceSelectionModal-voice-icon {\n    width: 40px;\n    height: 40px;\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
